import Review from '.';
import { RouteType } from '@/lib/route';

const ReviewRoutes: RouteType = {
  path: '/review/:tenantId/:elearningId/:type/:frameId?',
  component: Review,
};

export interface ReviewParamType {
  tenantId: string;
  elearningId: string;
  type: 'review' | 'live' | 'scorm';
  themeId: string;
  frameId: string;
}

export default ReviewRoutes;
